__turbopack_context__.v({
  "nextPrevButton": "tRnqfa_nextPrevButton",
  "placeholder": "tRnqfa_placeholder",
  "slide": "tRnqfa_slide",
  "wrapper": "tRnqfa_wrapper",
});
